<template>
  <span>
    <v-snackbar
      app
      v-model="showInstallBanner"
      :timeout="timeout"
      :outlined="outlined"
      color="transparent"
      :elevation="elevation"
      >
        <v-btn  rounded color="blue" class="ma-1" @click.prevent="install">
          <v-icon left dark>mdi-package-down</v-icon>
          Installer
        </v-btn>
      
        <v-btn class="ma-1" rounded color="warning" @click="showInstallBanner = false">
        <v-icon left dark>mdi-keyboard-backspace</v-icon>  Plus tard
        </v-btn>
     
    </v-snackbar>
  </span>
</template>
<script>
let installEvent;
export default {
  name: "installPrompt",
  data() {
    return {
      outlined: false,
      showInstallBanner: false,
      timeout: "-1",
      vertical: true,
      elevation: 0,
    };
  },
  created() {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      installEvent = e;
      this.showInstallBanner = true;
    });
  },
  methods: {
    install() {
      this.showInstallBanner = false;
      installEvent.prompt();
      installEvent.userChoice.then(() => {
        installEvent = null;
      });
    },
  },
};
</script>
